import { interleaveTwoArrays } from '@eventbrite/ads';
import { FormattedEvent } from '@eventbrite/event-renderer';

export function getSortedEvents(
    events: FormattedEvent[],
    promotedEvents: FormattedEvent[],
) {
    return interleaveTwoArrays(events, promotedEvents, [1, 3]);
}
